module.exports = __webpack_public_path__ + "img/Arrow_Out_Circle_Icon_Red.cd6dcb6f.svg";